var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75.181,
    height: 75.181,
    viewBox: "0 0 75.181 75.181",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2597",
    "data-name": "Groupe 2597",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2904",
    "data-name": "Trac\\xE9 2904",
    d: "M74.181,37.091A37.09,37.09,0,1,1,37.09,0a37.09,37.09,0,0,1,37.09,37.09",
    transform: "translate(0 -0.001)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2905",
    "data-name": "Trac\\xE9 2905",
    d: "M138.471,123.078h8.754V102.885h6.466l1.293-8.157h-7.759V88.561c0-2.288,2.188-3.581,4.277-3.581h3.78V78.216l-6.764-.3c-6.466-.4-10.047,4.675-10.047,10.743v6.068H131.11v8.157h7.361Z",
    transform: "translate(-107 -63.678)",
    fill: "#3a5998",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.d2c3927c8a002432e102940666fee2b8.svg";
export { ForwardRef as ReactComponent };